import { ref, computed } from "vue";
import { getParam } from "@utiles/index";
import { useBaseStore } from "@store/base";

export default function useCharInfo() {
  const base = useBaseStore();
  const roleId = ref("");
  const serverId = ref("");
  const roleName = ref("");
  const loginAccount = ref("");
  const gameId = computed(() => base.gameId);

  roleId.value =
    getParam("roleId") || getParam("role_id") || getParam("roleID") || "";
  serverId.value =
    getParam("serverId") || getParam("server_id") || getParam("serverID") || "";
  roleName.value = getParam("roleName") || getParam("role_name") || "";
  loginAccount.value =
    getParam("loginAccount") || getParam("login_account") || "";

  return {
    roleId,
    serverId,
    roleName,
    loginAccount,
    gameId,
  };
}
